var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatnotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#0065FF",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0833 15.8333C28.6917 15.8333 30 14.525 30 12.9167C30 11.3083 28.6917 10 27.0833 10C25.475 10 24.1667 11.3083 24.1667 12.9167C24.1667 14.525 25.475 15.8333 27.0833 15.8333ZM23.41 25.8333L23.8842 26.15C23.1225 26.975 22.0417 27.5 20.8333 27.5H16.0858L12.7825 29.7033C12.4833 29.9025 12.1592 30 11.7908 30C11.5008 30 11.2108 29.9325 10.945 29.79C10.3625 29.4775 10 28.8725 10 28.2117V17.5C10 15.4692 11.4625 13.7783 13.3875 13.4117C13.355 13.6592 13.3333 13.91 13.3333 14.1667V20C13.3333 23.2158 15.9508 25.8333 19.1667 25.8333H23.41ZM30 16.4492V24.8783C30 25.5392 29.6375 26.1442 29.055 26.4567C28.79 26.5992 28.4992 26.6692 28.2092 26.6692C27.8625 26.6692 27.5167 26.5683 27.2167 26.3692L23.9142 24.1667H19.1667C16.8692 24.1667 15 22.2975 15 20V14.1667C15 11.8692 16.8692 10 19.1667 10H23.5508C22.895 10.7933 22.5 11.8092 22.5 12.9167C22.5 15.4442 24.5558 17.5 27.0833 17.5C28.1908 17.5 29.2067 17.105 30 16.4492Z",
    fill: "#0065FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatnotification);
export default __webpack_public_path__ + "static/media/chatnotification.c23b19dbc334ef68c28819fc6fad07a6.svg";
export { ForwardRef as ReactComponent };